import React, { useState } from 'react';
import Styles from './BlogListBanner.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function BlogListBanner() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="blog-list-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 320 && (
                <picture>
                  <source type="image/webp" srcSet="assets/blog/hero/hero-320.webp" />
                  <source type="image/png" srcSet="assets/blog/hero/hero-320.png" />
                  <img
                    src="assets/blog/hero/hero-320.png"
                    alt="Mulher concentrada em computador em seu escritório pesquisando sobre temas de produtos, segurança, serviços, educação financeira e sustentabilidade no blog da Santander Financiamentos."
                  />
                </picture>
              )}
              {width > 320 && width <= 450 && (
                <picture>
                  <source type="image/webp" srcSet="assets/blog/hero/hero-450.webp" />
                  <source type="image/png" srcSet="assets/blog/hero/hero-450.png" />
                  <img
                    src="assets/blog/hero/hero-450.png"
                    alt="Mulher concentrada em computador em seu escritório pesquisando sobre temas de produtos, segurança, serviços, educação financeira e sustentabilidade no blog da Santander Financiamentos."
                  />
                </picture>
              )}
              {width > 450 && width <= 800 && (
                <picture>
                  <source type="image/webp" srcSet="assets/blog/hero/hero-800.webp" />
                  <source type="image/png" srcSet="assets/blog/hero/hero-800.png" />
                  <img
                    src="assets/blog/hero/hero-800.png"
                    alt="Mulher concentrada em computador em seu escritório pesquisando sobre temas de produtos, segurança, serviços, educação financeira e sustentabilidade no blog da Santander Financiamentos."
                  />
                </picture>
              )}
              {width > 800 && width <= 1280 && (
                <picture>
                  <source type="image/webp" srcSet="assets/blog/hero/hero-1280.webp" />
                  <source type="image/png" srcSet="assets/blog/hero/hero-1280.png" />
                  <img
                    src="assets/blog/hero/hero-1280.png"
                    alt="Mulher concentrada em computador em seu escritório pesquisando sobre temas de produtos, segurança, serviços, educação financeira e sustentabilidade no blog da Santander Financiamentos."
                  />
                </picture>
              )}
              {width > 1280 && width <= 1360 && (
                <picture>
                  <source type="image/webp" srcSet="assets/blog/hero/hero-1360.webp" />
                  <source type="image/png" srcSet="assets/blog/hero/hero-1360.png" />
                  <img
                    src="assets/blog/hero/hero-1360.png"
                    alt="Mulher concentrada em computador em seu escritório pesquisando sobre temas de produtos, segurança, serviços, educação financeira e sustentabilidade no blog da Santander Financiamentos."
                  />
                </picture>
              )}
              {width > 1360 && (
                <picture>
                  <source type="image/webp" srcSet="assets/blog/hero/hero-1440.webp" />
                  <source type="image/png" srcSet="assets/blog/hero/hero-1440.png" />
                  <img
                    src="assets/blog/hero/hero-1440.png"
                    alt="Mulher concentrada em computador em seu escritório pesquisando sobre temas de produtos, segurança, serviços, educação financeira e sustentabilidade no blog da Santander Financiamentos."
                  />
                </picture>
              )}
            </>
          )}
        </div>
        {/* <div className="fade-banner" /> */}
        {/* <div className="fade-hero-gradiente" /> */}
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Blog da Santander financiamentos</h1>
              <p className="alt-text">
                Conheça os conteúdos que a Santander Financiamentos oferece, incluindo dicas,
                informações sobre financiamentos e outros assuntos relevantes.
              </p>
              {/* <WhiteButton
                href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento:banner&int_campaign=consultar"
                rel="noopener"
                target="_blank"
                className="btn-simulate"
              >
                Consultar
              </WhiteButton> */}
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default BlogListBanner;
